var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cups.length > 0)?_c(_vm.component,_vm._b({tag:"component",attrs:{"value":_vm.cups,"short-name":_vm.shortName}},'component',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }